export default __webpack_public_path__ + "static/media/lampas1-min.592e69e9.jpg";